import React from "react";
import PropTypes from "prop-types";

import { questionProps } from "lib/propTypes";
import Availability, { SHIFT_DEFAULTS } from "common/Availability";

export default class PrefAvailabilityQuestion extends React.PureComponent {
    static propTypes = {
        ...questionProps,
        handleAnswer: PropTypes.func.isRequired,
    };

    componentDidMount() {
        // Set the defaults so the next button is immediately active
        this.handleUpdate({ ...SHIFT_DEFAULTS });
    }

    handleUpdate = ({
        pref_shift_day,
        pref_shift_swing,
        pref_shift_night,
        pref_shift_weekend,
        pref_shift_overtime,
    }) => {
        /* eslint-disable camelcase */
        this.props.handleAnswer({
            questionID: this.props.id,
            response: {
                pref_shift_day,
                pref_shift_swing,
                pref_shift_night,
                pref_shift_weekend,
                pref_shift_overtime,
            },
        });
        /* eslint-enable */
    };

    render() {
        const props = {
            ...SHIFT_DEFAULTS,
            handleUpdate: this.handleUpdate,
        };

        return (
            <div>
                <label className="questions__title questions__avail-label">
                    {this.props.question}
                </label>
                <Availability {...props} />
            </div>
        );
    }
}
